import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstants } from '../../app.constants';

@Injectable()
export class ParentDataService {
  constructor(private appConstants: AppConstants, private _http: HttpClient) { }

  getChildren(parentId) {
    //let parentId = localStorage.getItem('ng2-webstorage|parentportalparentid').replace(/['"]+/g, '')

    return this._http.get(`${this.appConstants.baseUrl}GetStudentDetailsByParentId?parentid=${parentId}`);
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/service/parent-data.service.ts